export const UNIT_FAMILIES: Record<string, { base: string; units: Record<string, number> }> = {
  weight: { base: 'g', units: { g: 1, kg: 1000, mg: 0.001 } },
  volume: { base: 'ml', units: { ml: 1, L: 1000, dL: 100 } },
  count:  { base: 'un', units: { un: 1, dz: 12 } },
  length: { base: 'cm', units: { cm: 1, m: 100, mm: 0.1 } },
};

export const PACKAGE_UNITS = ['cx', 'pct', 'pc', 'pacote', 'caixa', 'emb', 'pack'];

export function inferUnitFamily(unit?: string | null): string {
  if (!unit) return 'other';
  const u = unit.toLowerCase();
  if (['kg', 'g', 'mg'].includes(u)) return 'weight';
  if (['l', 'ml', 'dl'].includes(u)) return 'volume';
  if (['un', 'cx', 'pc', 'pct', 'dz'].includes(u)) return 'count';
  if (['m', 'cm', 'mm'].includes(u)) return 'length';
  return 'other';
}

function normalizeUnits(family?: { units: Record<string, number> }): Record<string, number> {
  const norm: Record<string, number> = {};
  if (!family) return norm;
  Object.entries(family.units).forEach(([k, v]) => { norm[k.toLowerCase()] = v; });
  return norm;
}

export function convertToBase(quantity: number, unit?: string | null, unitFamily?: string | null, quantityPerPackage = 0): number {
  if (!quantity || quantity <= 0) return 0;
  const family = UNIT_FAMILIES[unitFamily || ''];
  if (!family) return quantity;
  const u = (unit || '').toLowerCase();
  if (PACKAGE_UNITS.includes(u) && quantityPerPackage > 0) {
    return quantity * quantityPerPackage;
  }
  const multiplier = normalizeUnits(family)[u];
  return multiplier != null ? quantity * multiplier : quantity;
}
